export default "__VITE_ASSET__4guBRzBT__"